import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/gnp-logo01.webp`} 
              alt="Gardens of North Port" 
              className="logo-image"
            />
          </Link>
        </div>

        <ul className="navbar-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/#care-options">Care Options</Link></li>
          <li><Link to="/#amenities">Amenities</Link></li>
          <li><Link to="/#residences">Residences</Link></li>
          <li><Link to="/#testimonials">Testimonials</Link></li>
        </ul>

        <div className="navbar-cta">
          <span className="navbar-phone-text">(941) 249-2344</span>
          <a href="tel:9412492344" className="navbar-phone-btn" aria-label="Call us">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.6 10.8C7.8 13.2 9.8 15.2 12.2 16.4L14.1 14.5C14.35 14.25 14.7 14.18 15 14.32C16.05 14.7 17.2 14.9 18.4 14.9C18.9 14.9 19.3 15.3 19.3 15.8V18.4C19.3 18.9 18.9 19.3 18.4 19.3C10.3 19.3 3.7 12.7 3.7 4.6C3.7 4.1 4.1 3.7 4.6 3.7H7.2C7.7 3.7 8.1 4.1 8.1 4.6C8.1 5.8 8.3 6.95 8.68 8C8.82 8.3 8.75 8.65 8.5 8.9L6.6 10.8Z" fill="currentColor" />
            </svg>
          </a>
        </div>
      </nav>

      <div className="privacy-policy-container">
        <Link to="/" className="back-to-home">← Back to Home</Link>
        
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: April 2026</p>
        
        <div className="policy-content">
          <p>
            At Gardens of North Port, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect, how we use it, and the choices you have when interacting with our website and our community.
          </p>
          <p>
            By using this website or submitting your details through our forms, you agree to the terms of this Privacy Policy.
          </p>

          <h2>1. Who We Are</h2>
          <p>Gardens of North Port is a senior living community located at:</p>
          <p className="address-block">
            <strong>Gardens of North Port</strong><br />
            4900 S Sumter Blvd<br />
            North Port, FL 34287<br />
            Phone: (941) 249-2344<br />
            FL License #10843 · Part of North Port Retirement Centers
          </p>
          <p>
            This website provides information about our community, care options, residences, amenities, and ways to contact us or schedule a tour.
          </p>

          <h2>2. Information We Collect</h2>
          <p>We collect information in several ways when you use our website or communicate with us.</p>
          
          <h3>a) Information You Provide Directly</h3>
          <p>You may share information with us when you:</p>
          <ul>
            <li>Request a lunch tour or schedule a visit</li>
            <li>Call us via the phone number listed</li>
            <li>Fill out contact or inquiry forms</li>
            <li>Communicate via email or phone</li>
          </ul>
          <p>This information may include:</p>
          <ul>
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Best time to call</li>
            <li>Type of care you're interested in</li>
            <li>Any additional details or messages</li>
          </ul>
          <p><strong>Note:</strong> Please avoid sharing sensitive health or financial information through website forms.</p>

          <h3>b) Information Collected Automatically</h3>
          <p>When you visit our website, we may collect:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Device type and operating system</li>
            <li>Pages visited and time spent</li>
            <li>Referring website</li>
          </ul>
          <p>This helps us improve website performance and user experience.</p>

          <h3>c) Cookies and Similar Technologies</h3>
          <p>We use cookies to:</p>
          <ul>
            <li>Remember your preferences</li>
            <li>Improve performance and security</li>
            <li>Understand user behavior</li>
          </ul>
          <p>You can disable cookies in your browser settings, but some features may not function properly.</p>

          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Respond to inquiries</li>
            <li>Schedule and follow up on tours</li>
            <li>Help you choose the right care options</li>
            <li>Share updates on services, pricing, and availability</li>
            <li>Improve our website and services</li>
            <li>Maintain system security</li>
          </ul>
          <p>You can request to limit or stop communication at any time.</p>

          <h2>4. How We Share Your Information</h2>
          <p>We do not sell your personal information.</p>
          <p>We may share information only in these cases:</p>
          <ul>
            <li><strong>Within our organization:</strong> Authorized staff members</li>
            <li><strong>Service providers:</strong> Trusted partners managing website or communication tools</li>
            <li><strong>Legal reasons:</strong> When required by law or for safety purposes</li>
          </ul>
          <p>All third parties are required to protect your information.</p>

          <h2>5. How We Protect Your Information</h2>
          <p>We implement reasonable administrative, technical, and physical safeguards to protect your data.</p>

          <h2>6. How Long We Keep Your Information</h2>
          <p>We retain your information only as long as necessary to:</p>
          <ul>
            <li>Respond to your requests</li>
            <li>Provide services</li>
            <li>Meet legal and regulatory requirements</li>
            <li>Support business operations</li>
          </ul>
          <p>We delete or anonymize data when no longer needed.</p>

          <h2>7. Your Choices and Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Update or correct your information</li>
            <li>Limit how your data is used</li>
            <li>Request access to your personal data</li>
          </ul>
          <p>To exercise these rights, contact us using the details below.</p>

          <h2>8. Third-Party Links</h2>
          <p>Our website may include links to external platforms such as social media.</p>
          <p>We are not responsible for their privacy practices. Please review their policies separately.</p>

          <h2>9. Children's Privacy</h2>
          <p>This website is intended for adults researching senior living options.</p>
          <p>We do not knowingly collect data from children under 13. If this occurs, please contact us for removal.</p>

          <h2>10. Changes to This Policy</h2>
          <p>We may update this policy periodically.</p>
          <p>Any changes will be reflected in the "Last Updated" date. Continued use of the site means acceptance of updates.</p>

          <h2>11. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us:</p>
          <p className="address-block">
            <strong>Gardens of North Port</strong><br />
            4900 S Sumter Blvd<br />
            North Port, FL 34287<br />
            Phone: (941) 249-2344
          </p>
          <p>We are happy to assist you and ensure your information is handled responsibly.</p>
        </div>
      </div>

      <footer className="custom-footer">
        <div className="custom-footer-main">
          {/* About */}
          <div>
            <h2>About Gardens of North Port</h2>
            <p>
              Gardens of North Port is a caring senior living community where comfort, dignity, and connection come together in a beautiful North Port setting. With thoughtfully prepared meals, welcoming residences, enriching activities, and attentive support, we help residents enjoy a safer, more joyful everyday life.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h2>Contact Information</h2>
            <div>Phone: (941) 249-2344</div>
            <div>Location: North Port, Florida</div>
          </div>

          {/* Information */}
          <div>
            <h2>Information</h2>
            <div><Link to="/privacy-policy">Privacy Policy</Link></div>
            <div><Link to="/terms-and-conditions">Terms &amp; Condition</Link></div>
          </div>
        </div>
        <hr />
        <div className="custom-footer-bottom">
          <div>
            © 2026 Gardens of North Port. All rights reserved. FL Lic. #10843. Located at 4900 S Sumter Blvd, North Port, FL 34287. This website is provided for general informational purposes only. Community services, amenities, residence availability, and care options may change without notice. Images and descriptions are representative and may vary. By submitting your information, you consent to being contacted by our team regarding tours, services, and availability.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
